/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Voice_Manager_Elevenlabs_ErrorInputs */

const en_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't load your ElevenLabs voices. ${i?.error}`)
};

const fr_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible de charger vos voix ElevenLabs. ${i?.error}`)
};

const de_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihre ElevenLabs-Stimmen konnten nicht geladen werden. ${i?.error}`)
};

const it_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le tue voci ElevenLabs. ${i?.error}`)
};

const ru_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить голоса ElevenLabs. ${i?.error}`)
};

const es_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar tus voces de ElevenLabs. ${i?.error}`)
};

const zh_cn2_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法加载您的 ElevenLabs 语音。${i?.error}`)
};

const ja_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ElevenLabs の音声を読み込めませんでした。${i?.error}`)
};

const hi_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपकी ElevenLabs आवाज़ें लोड नहीं हो सकीं। ${i?.error}`)
};

const pt_pt2_voice_manager_elevenlabs_error = /** @type {(inputs: Voice_Manager_Elevenlabs_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as suas vozes da ElevenLabs. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Couldn't load your ElevenLabs voices. {error}" |
*
* @param {Voice_Manager_Elevenlabs_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_error = /** @type {((inputs: Voice_Manager_Elevenlabs_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_elevenlabs_error(inputs)
	if (locale === "de") return de_voice_manager_elevenlabs_error(inputs)
	if (locale === "it") return it_voice_manager_elevenlabs_error(inputs)
	if (locale === "ru") return ru_voice_manager_elevenlabs_error(inputs)
	if (locale === "es") return es_voice_manager_elevenlabs_error(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_elevenlabs_error(inputs)
	if (locale === "ja") return ja_voice_manager_elevenlabs_error(inputs)
	if (locale === "hi") return hi_voice_manager_elevenlabs_error(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_elevenlabs_error(inputs)
	return en_voice_manager_elevenlabs_error(inputs)
});